<template>
    <SettingsPage title="Navigation Links">
        <template v-slot:settingsForms>
            <SettingsForm :settingsLoading="settingsLoading" form="newUserRegistration">
                <template v-slot:form>
                    <form action="" method="POST" id="newUserRegistration" @submit.prevent="saveNavigationLinks" v-if="!settingsLoading && settings">

                        <v-row dense v-for="(link, index) in navigationLinks" :key="index">
                            <v-col cols="12" md="3">
                                <v-autocomplete
                                        :items="pages"
                                        label="Page"
                                        v-model="navigationLinks[index].page_id"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="3">
                                <v-text-field label="Name (Button Text)"
                                              :name="navigationLinks[index]+'name'"
                                              v-model="navigationLinks[index].name"
                                              outlined
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="3">
                                <v-text-field label="Icon"
                                              :name="navigationLinks[index]+'icon'"
                                              v-model="navigationLinks[index].icon"
                                              outlined
                                              :append-icon="navigationLinks[index].icon"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-text-field label="Tooltip"
                                              name="slot1Page"
                                              v-model="navigationLinks[index].tooltip"
                                              outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" class="align-center justify-center items-center">
                                <v-btn color="primary"
                                       large
                                       @click="saveNavigationLink(navigationLinks[index])"
                                >Save</v-btn>
                            </v-col>
                        </v-row>
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import axios from 'axios';
import notify from '@/store/Common/notify';
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';

export default {
    mixins: [ settingsMixin ],
    components: { SettingsForm, SettingsPage },
    props: [],

    data() {
        return {
            navigationLinks: [],
            pages: [],
        };
    },

    mounted() {
        this.getNavigationLinks();
    },

    methods: {
        getNavigationLinks() {
            axios.get('/api/navigation-link/index')
                .then(response => {
                    this.navigationLinks = response.data.data.navigationLinks.links;
                    this.pages = response.data.data.navigationLinks.pages;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        saveNavigationLink(linkData) {
            axios.post('/api/navigation-link/edit/' + linkData.id, linkData)
                .then(() => {
                    notify('Link Saved Successfully', 'success');
                })
                .catch(error => {
                    console.log(error);
                    notify('Not saved. Check console for error.', 'error');
                });
        },
    }
};
</script>
